/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Stringvalue1Inputs */

const en_entity_stringvalue1 = /** @type {(inputs: Entity_Stringvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`String Value`)
};

const de_entity_stringvalue1 = /** @type {(inputs: Entity_Stringvalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichenfolgenwert`)
};

/**
* | output |
* | --- |
* | "String Value" |
*
* @param {Entity_Stringvalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_stringvalue1 = /** @type {((inputs?: Entity_Stringvalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Stringvalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_stringvalue1(inputs)
	return de_entity_stringvalue1(inputs)
});
export { entity_stringvalue1 as "entity_stringValue" }